import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ExtraOptions, NoPreloading, RouterModule } from "@angular/router";
import { FuseModule } from "@fuse";
import { FuseConfigModule } from "@fuse/services/config";
import { FuseMockApiModule } from "@fuse/lib/mock-api";
import { CoreModule } from "app/core/core.module";
import { appConfig } from "app/core/config/app.config";
import { mockApiServices } from "app/mock-api";
import { LayoutModule } from "app/layout/layout.module";
import { AppComponent } from "app/app.component";
import { appRoutes } from "app/app.routing";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "./../environments/environment";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { interceptorProviders } from "./interceptors/interceptors";
import { SpinnerComponent } from "./shared/spinner.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
const routerConfig: ExtraOptions = {
  preloadingStrategy: NoPreloading,
  scrollPositionRestoration: "enabled",
};

@NgModule({
  declarations: [AppComponent, SpinnerComponent],
  imports: [
    MatProgressSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerImmediately",
      // registrationStrategy: 'registerWhenStable:30000'
    }),

    // 3rd party modules that require global configuration via forRoot
    //MarkdownModule.forRoot({})
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: "en-GB",
    },
    interceptorProviders,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: "dynamic", FloatLabelType: "auto" },
    },
  ],
})
export class AppModule {}
